import { render } from "./Toasts.vue?vue&type=template&id=af9987a2"
import script from "./Toasts.vue?vue&type=script&lang=js"
export * from "./Toasts.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__